import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { FormBuilderModule } from '@nohs/form-builder';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { authInterceptorFn } from './app/interceptors/auth.interceptor';
import { handle401InterceptorFn } from './app/interceptors/handle401.interceptor';
import { urlInterceptorFn } from './app/interceptors/url.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(BrowserModule, AppRoutingModule, FormBuilderModule.forRoot()),
    provideHttpClient(withInterceptors([urlInterceptorFn, authInterceptorFn, handle401InterceptorFn])),
    provideAnimations(),
    {
      provide: ErrorHandler,
      useClass: ApplicationinsightsAngularpluginErrorService,
    },
  ],
}).catch((err) => console.error(err));
